import {
  objectTypesGet,
  objectTypesCreate,
  objectTypesUpdate
} from "@/api/objectTypes.api";

import { VIRTUAL } from "@/domain/object.types";

import {
  OBJECT_TYPES_GET,
  OBJECT_TYPES_CREATE,
  OBJECT_TYPES_UPDATE,
  OBJECT_TYPES_CLEAR
} from "../type";

const state = {
  objectTypes: []
};

const getters = {
  virtualObjectTypes: state =>
    state.objectTypes.filter(t => t.type === VIRTUAL && t.used.length > 0),
  usedObjectTypes: state => state.objectTypes.filter(t => t.used.length > 0)
};

const actions = {
  async [OBJECT_TYPES_GET]({ commit }, lang) {
    try {
      const response = await objectTypesGet(lang);
      commit(OBJECT_TYPES_GET, response.data.typesOfObjects);
      return response.status;
    } catch (err) {
      return err.response.status;
    }
  },
  async [OBJECT_TYPES_CREATE](undefined, { lang, data }) {
    try {
      const response = await objectTypesCreate(lang, data);
      return response.data;
    } catch (err) {
      return err.response.status;
    }
  },
  async [OBJECT_TYPES_UPDATE](undefined, { id, lang, data }) {
    try {
      const response = await objectTypesUpdate(id, lang, data);
      return response.data;
    } catch (err) {
      return err.response.status;
    }
  }
};

const mutations = {
  [OBJECT_TYPES_GET](state, refs) {
    state.objectTypes = refs;
  },
  [OBJECT_TYPES_CLEAR](state) {
    state.objectTypes = [];
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
